import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  InputAdornment,
  TextField,
  Icon,
} from '@material-ui/core';
import classNames from 'classnames';
import styled from 'styled-components';

import Tabs from './Tabs';
import { fuseDark } from '@fuse/fuse-colors'
import { fetchCompanyHistory, setCompaniesInfo } from '../../../../store/actions';
import Util from "../../../../yeffect/utils";
import axios from "axios";
import {TICKER_API} from "../../../../config";

const Span = styled.span`
	width: ${props => props.width}%;
	text-align: center;
	font-size: 12px;

	&.bold {
		font-weight: bold;
	}
`;

const TAB_FILTER = ['E', 'C', 'D', 'I'];

const styles = theme => ({
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  watchList: {
    padding: 20,
    height: '100%',
    borderRight: '1px solid #595b5f',
    boxShadow: '8px 0px 8px 0px rgba(0, 0, 0, 0.48)',
  },
  tabContentWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  watchListHeader: {
    textAlign: 'center'
  },
  contentWrapper: {
    overflow: 'auto',
  },
  fullbox: {
    height: '100%',
  },
  title: {
    color: 'white',
  },
  margin20: {
    margin: 20,
  },
  margin: {
    margin: '20px 10px',
  },
  textField: {
    flex: 'none',
    width: 'calc(100% - 20px)',
  },
  badge: {
    '& > span': {
      top: 0,
      right: -30,
    }
  },
  tableHeader: {
    background: '#2a2e36',
    height: 30,
  },
  tableRow: {
    width: '100%',
    padding: '10px',
    borderBottom: '1px solid #2a2e36',
    height: 30,
    cursor: 'pointer',

    '&.selected': {
      background: '#494e56',
    },

    '@media (max-width: 1680px)': {
      paddingLeft: 0,
      paddingRight: 0,
      lineHeight: 1
    }
  },
  symbolField: {
    textAlign: 'left',
    paddingLeft: '20px',

    '@media (max-width: 1680px)': {
      paddingLeft: '10px',
    }
  }
});

class WatchList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      tab1: 0,
      seconds: 0,
      sortIndex: 0,
      sortOrder: -1,  //1: asc, -1 : desc
      companies: [],
      query: '',
    };

    this.handleQueryChange = this.handleQueryChange.bind(this);
  }

  tick() {
    this.setState(prevState => ({
      seconds: prevState + 1
    }));
  }

  componentDidMount() {
    this.interval = setInterval(() => this.updateCompanyList(), 5000);
  }

  componentWillUnMount() {
    clearInterval(this.interval);
  }

  updateCompanyList(){
    const app = this;
    axios.get(TICKER_API + '/companies').then(x=>{
      app.setState({
        companies: x.data
      }, () => {
        app.props.setCompaniesInfo(x.data);
        app._filterCompany();
      })
    });
  }

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  _filterCompany = () => {
    const { query, companies, tab1 } = this.state;

    this.setState({
      companies: companies.filter((com) => 
        com.share_type === TAB_FILTER[tab1] &&
        (com.name.toLowerCase().includes(query) || com.symbol.toLowerCase().includes(query))
      )
    });
  }

  handleQueryChange(ev) {
    this.setState({ query: ev.target.value.toLowerCase() }, () => this._filterCompany());
  }

  getChangeColor = (change) => {
    if (change < 0) {
      return 'red';
    } else if (change > 0) {
      return fuseDark.colGreen;
    }
    return 'black';
  };

  getChangeIcon = (change, color) => {
    if (change > 0) {
      return (<span className={classNames('material-icons')} style={{ color: color, marginLeft: -7, marginRight: -7 }}>arrow_drop_up</span>);
    } else if (change < 0) {
      return <span className={classNames('material-icons')} style={{ color: color, marginLeft: -7, marginRight: -7 }}>arrow_drop_down</span>;
    }
    return ' ';
  };

  handleSort = (index) => {
    const { sortOrder } = this.state;
    this.setState({ sortIndex: index, sortOrder: -sortOrder });
  };

  render() {
    const { classes, isLoading, selectCompany, selectedCompany } = this.props;
    const { companies } = this.state;
    const { tab1, sortIndex, sortOrder } = this.state;
    const TAB_ARRAY = ['EQUITIES', 'FUNDS', 'BONDS', 'ICOS'];
    // const COLOR_ARRAY = ['#f59331', '#144328', '#75624f', '#613420'];

    //eslint-disable-line no-use-before-define
    companies.sort((left, right) => {
      switch (sortIndex) {
        case 0:
          return (right.symbol > left.symbol ? 1 : -1) * sortOrder;
        case 1:
          return (right.share_price - left.share_price) * sortOrder;
        case 2:
          let rightPercent = right.share_price / right.open;
          let leftPercent = left.share_price / left.open;
          rightPercent = isNaN(rightPercent) ? 0 : rightPercent;
          leftPercent = isNaN(leftPercent) ? 0 : leftPercent;
          return (rightPercent - leftPercent) * sortOrder;
        case 3:
          return (right.currency > left.currency ? 1 : -1) * sortOrder;
        default:
          return right.id - left.id;
      }
    });
    return (
      <div className={classes.watchList}>
        <Tabs
          name={'tab1'}
          tabs={TAB_ARRAY}
          value={tab1}
          selectedColor={'#f59331'}
          onChange={this.handleChange}
        >
          {
            <div className={classes.tabContentWrapper}>
              <TextField
                id="outlined-adornment-weight"
                className={classNames(classes.margin, classes.textField)}
                variant="outlined"
                type="search"
                placeholder="SEARCH"
                InputProps={{
                  startAdornment: <InputAdornment position="end"><span className="material-icons">search</span></InputAdornment>,
                  style: {
                    color: 'white',
                    background: '#2e323a',
                    borderRadius: 4,
                    fontSize: 12,
                    padding: 5
                  },
                }}
                // eslint-disable-next-line
                inputProps={{
                  style: {
                    padding: 5,
                  }
                }}
                InputLabelProps={{
                  style: {
                    fontSize: 12,
                    color: 'white',
                  },
                }}
                onChange={this.handleQueryChange}
              />
              <div className={classNames(classes.flexBox, classes.tableRow)} style={{ width: '98%', paddingRight: 10 }}>
                <span style={{ display: 'flex', alignItems: 'center', width: '30%', textAlign: 'left' }}>
                  <Span className={classNames('bold', classes.symbolField)} onClick={() => this.handleSort(0)}>SYMBOL</Span>
                  {sortIndex === 0 && <Icon style={{ marginLeft: -7 }}>{sortOrder === 1 ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>}
                </span>
                <span className={classNames(classes.watchListHeader)} style={{ width: '20%' }}>
                  <Span className={'bold'} onClick={() => this.handleSort(1)}>PRICE</Span>
                  {sortIndex === 1 && <Icon style={{ marginLeft: -7 }}>{sortOrder === 1 ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>}
                </span>
                <span className={classNames(classes.watchListHeader)} style={{ width: '30%' }}>
                  <Span className={'bold'} onClick={() => this.handleSort(2)}>CHANGE</Span>
                  {sortIndex === 2 && <Icon style={{ marginLeft: -7 }}>{sortOrder === 1 ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>}
                </span>
                <span className={classNames(classes.watchListHeader)} style={{ width: '20%' }}>
                  <Span className={'bold'} onClick={() => this.handleSort(3)}>CURRENCY</Span>
                  {sortIndex === 3 && <Icon style={{ marginLeft: -7 }}>{sortOrder === 1 ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>}
                </span>
              </div>
              {
                isLoading && <div>Loading...</div>
              }
              {
                !isLoading && companies !== undefined &&
                <div className={classes.contentWrapper}>
                  {
                    companies.map(company => {
                      let selected = '';
                      const { symbol, share_price, open, currency, status } = company;

                      const change = (share_price - open).toFixed(2);
                      let changePercent = '';
                      if (change === open || change === '0.00' || change === null || open === null) {
                        changePercent = '0.00';
                      } else if (isFinite(change / open)) {
                        changePercent = ((change / open) * 100).toFixed(2);
                      }
                      const sign = change > 0 ? '+' : '';
                      const color = this.getChangeColor(change);
                      const icon = this.getChangeIcon(change, color);

                      let { currency_symbol } = Util.getCurrency(company.currency);
                      if (company.id === selectedCompany) selected = 'selected';

                      return (
                        <div key={company.id}
                          className={classNames(classes.flexBox, classes.tableRow, selected)}
                          onClick={() => selectCompany(company.id)}
                        >
                          <Span width={25} className={classNames(classes.symbolField)}>{symbol}</Span>
                          <Span width={5} style={{ textAlign: 'center' }}>{
                            status === '2' || status === '3' ? <i className="material-icons" style={{ fontWeight: 'light', fontSize: '20px', marginRight: '5px' }}>announcement</i> : (
                              status === '4' ? <i className="material-icons" style={{ fontWeight: 'light', fontSize: '20px', marginRight: '5px' }}>pan_tool</i> : ' ')} </Span>
                          <Span width={20}>{currency_symbol}{Util.addThousandCommas(share_price, '0, 0.00')}</Span>
                          <Span width={30} className={classes.flexBox} style={{ justifyContent: 'center' }}>
                            <strong style={{ color: color }}>{sign + Util.addThousandCommas(change)}</strong>
                            {icon}
                            <strong style={{ color: color }}>({changePercent}%)</strong>
                          </Span>
                          <Span width={20}>{currency}</Span>
                        </div>
                      )
                    })
                  }
                </div>
              }
            </div>
          }
        </Tabs>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  selectedCompany: state.company.selectedCompany,
});

const mapDispatchToProps = {
  selectCompany: fetchCompanyHistory,
  setCompaniesInfo,
};

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(WatchList));



// WEBPACK FOOTER //
// ./src/main/content/dashboard/components/WatchList.js